const config = {
  cmnHeader: "https://api.dhwani.click",
};
export default config;
